import { omit } from 'lodash/fp';
import useLocalStorage from './useLocalStorage';

const DEFAULT_EXPIRATION_DAYS = 31;
const PREFIX = 'warnings';

type WarningsMuterOptions = {
    expirationDays?: number | null;
};

function isExpired(timestamp: number, expirationDays: number) {
    const ms = expirationDays * 86400000;
    return Date.now() > timestamp + ms;
}

export function useWarningsMuter({ expirationDays = DEFAULT_EXPIRATION_DAYS }: WarningsMuterOptions = {}) {
    const [muted, setMuted] = useLocalStorage<Record<string, number>>(PREFIX, {});

    function mute(id: string) {
        setMuted({ ...muted, [id]: Date.now() });
    }

    function unmuteMany(ids: string[]) {
        setMuted(omit(ids, muted));
    }

    function unmute(id: string) {
        unmuteMany([id]);
    }

    function clearAll() {
        setMuted({});
    }

    function isMuted(id: string) {
        const ts = muted[id];
        if (!ts) return false;
        if (expirationDays !== null && isExpired(ts, expirationDays)) {
            unmute(id);
            return false;
        }
        return true;
    }

    return { mute, unmute, unmuteMany, clearAll, isMuted, muted };
}
